import { AuthService } from '@app/services';
import { NameColumn } from './columns';
import { Table } from '@app/modules/table/classes/table.class';
import { Employee } from '@models/employee/employee.model';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { Paginator } from '@app/classes';

const removeAction = {
    label: 'remove',
    event: 'MenuItemSelected',
};

export class EditEnrolledEmployeesTable extends Table {
    links = false;
    loaded = false;
    showMenuColumnOptions = true;
    employeeIds: number[];

    constructor(protected auth: AuthService) {
        super(auth);
        this.setEmployeeIds([]);
    }

    getMenuColumnOptionsForRow(): MenuColumnItem[] {
        return [removeAction];
    }

    setEmployeeIds(ids: number[]): void {
        this.employeeIds = ids;
        if (this.loaded) {
            this.setDataSource().reload();
            return;
        }
        this.boot();
        this.loaded = true;
    }

    setColumns(): void {
        this.columns = [new NameColumn()];
    }

    setDataSource(): this {
        const query = Employee.param('company', this.auth.company.id).limit(5).whereIn('id', this.employeeIds);

        if (this.loaded) {
            this.paginator.updateQuery(query);
            return this;
        }
        this.paginator = new Paginator(query, { pageSize: 5 });
        return this;
    }
}
